import * as Yup from 'yup';

export const emailRegExp = /^[\w.+-]+@([\w-]+\.)+[\w-]{2,4}$/g
export const passwordRegExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\da-zA-Z]).+$/
export const required_message = 'This field is required.';
export const password_message = 'Password should contain: at least one uppercase and one lowercase letter, one number and one symbol.';

export const signInSchema = Yup.object().shape({
    email: Yup.string()
        .required(`${required_message}`)
        .matches(emailRegExp, 'The email format is incorrect.')
        .max(255, 'Email must be max 255 characters.'),
})
export const signUpSchema = Yup.object().shape({
    first_name:  Yup.string()
    .required(`${required_message}`)
    .matches(
        /^[A-Za-z]+(?: [A-Za-z]+)*$/,
        'First name must contain only letters and spaces.'
    )
    .max(50, 'First name must be max 50 characters.'),
    email: Yup.string()
        .required(`${required_message}`)
        .matches(emailRegExp, 'The email format is incorrect.')
        .max(255, 'Email must be max 255 characters.'),
    password: Yup.string()
        .required(`${required_message}`)
        .min(8, 'Password must be at least 8 characters.')
        .max(128, 'Password must be max 128 characters.')
        .matches(passwordRegExp, password_message),
})
export const verifySchema = Yup.object().shape({
    code: Yup.string()
        .required(`${required_message}`)
        .matches(/^[0-9]{4}$/, 'Verification code must be exactly 4 digits.'),
})